import React from "react";
import { IconButton, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface ModalHeaderProps {
  onClose: () => void;
  title: string;
}

export const ModalHeader: React.FC<ModalHeaderProps> = ({ onClose, title }) => (
  <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ borderBottom: "1px solid #DAE0E2" }}>
    <Typography>{title}</Typography>
    <IconButton onClick={onClose}>
      <CloseIcon className="icon" />
    </IconButton>
  </Stack>
);
